import React from 'react';
import { BarChart, ChartContainer } from 'components';
import { Loadable } from 'components/types';
import { IPayoutStateByDate } from 'types';
import { paymentStatToChartPoints } from 'utils';

interface IOverviewTabChartProps extends Loadable {
  paymentStats?: IPayoutStateByDate[];
}

const OverviewTabChart = ({ isLoading: statsLoading, paymentStats }: IOverviewTabChartProps) => {
  const chartData = paymentStats ? paymentStatToChartPoints(paymentStats) : [];

  return (
    <ChartContainer>
      <BarChart isLoading={statsLoading} data={chartData} />
    </ChartContainer>
  );
};

export default OverviewTabChart;
